import React from 'react';
import styles from './style.module.css';
import Tooltip from '../tooltip';

export default ({
    input,
    meta: {
        error,
        submitFailed
    } = {},
    name = input.name ? input.name : 'select',
    label = false,
    tooltip = false,
    prefix = false,
    options = []
} = {}) => (
    <div
        className={
            submitFailed && error ? styles.inputError : styles.container
        }
    >
        {
            label &&
            <div className={styles.labelContainer}>
                <label
                    htmlFor={name}
                    className={styles.label}
                >
                    {label}
                </label>
                {
                    tooltip &&
                    <Tooltip content={tooltip}/>
                }
            </div>
        }
        <div className={styles.inputContainer}>
            {
                prefix &&
                <span className={styles.prefix}>{prefix}</span>
            }
            <select
                {...input}
                id={name}
                className={styles.select}
            >
                { Object.keys(options).map((key) => <option key={key} value={key}>{options[key]}</option>) }
            </select>
            {
                submitFailed && error &&
                <span className={styles.errorDot}/>
            }
        </div>
        {
            submitFailed && error &&
            error.map((message, i) => <span key={i} className={styles.errorMessage}>{message}</span>)
        }
    </div>
);
